import { useState } from 'react';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { IconButton, ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material';

export interface RowAction {
  key: string;
  label: string;
  icon: React.ReactNode;
  /** Renders the item in the error color (hard deletes). */
  destructive?: boolean;
}

interface RowActionsMenuProps {
  ariaLabel: string;
  actions: RowAction[];
  /** Called with the selected action's key. Omit for inert design-review mocks. */
  onSelect?: (key: string) => void;
}

/**
 * Per-row kebab menu shared by the clinical cards. Hosts wire `onSelect` to
 * the domain's edit modal / soft-resolve / delete mutations.
 */
export const RowActionsMenu: React.FC<RowActionsMenuProps> = ({
  ariaLabel,
  actions,
  onSelect,
}) => {
  const [anchor, setAnchor] = useState<HTMLElement | null>(null);
  const close = () => setAnchor(null);

  return (
    <>
      <IconButton
        size="small"
        aria-label={ariaLabel}
        onClick={(event) => setAnchor(event.currentTarget)}
      >
        <MoreVertIcon fontSize="small" />
      </IconButton>
      <Menu anchorEl={anchor} open={Boolean(anchor)} onClose={close}>
        {actions.map((action) => (
          <MenuItem
            key={action.key}
            onClick={() => {
              close();
              onSelect?.(action.key);
            }}
            sx={action.destructive ? { color: 'error.main' } : undefined}
          >
            <ListItemIcon sx={action.destructive ? { color: 'error.main' } : undefined}>
              {action.icon}
            </ListItemIcon>
            <ListItemText>{action.label}</ListItemText>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};
